import { Injectable } from '@angular/core';
import {BehaviorSubject, from, Observable, ObservableInput} from 'rxjs';

import { HttpService } from '../http.service';
import {Storage} from '@ionic/storage-angular';

const TOKEN_KEY = 'auth-token';
const QUICK_TOKEN_KEY = 'auth-qtoken';
const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  isQAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);


  private path = 'login';
  private pathQuick = 'quicklogin';
  private pathAuth = 'quickauth';
  private resetPath = 'resetpassword';
  private forgotPath = 'forgotpassword';
  private checkResetPath = 'checkreset';
  private checkPath = 'check';
  private registerPath = 'registeraccount';
  private logoutPath = 'logout';
  private refreshPath = 'refresh';

  public sessionToken;
  public qsessionToken;


  constructor(public httpService: HttpService, private storage: Storage) {
      this.storage.create();
      this.getSessionToken();
  }


  doLogin(body): Observable<any>{
    this.setSessionToken('');
    return this.httpService.httpPost(this.path, body).pipe(response => {
      return response;
    });
  }

  clearQuickCode(){
    localStorage.setItem('token', '');
    localStorage.setItem('quicklogin', '');
  }


  forgotPassword(body): Observable<any>{
    return this.httpService.httpPost(this.forgotPath, body).pipe(response => {
      return response;
    });
  }

  checkresetPassword(token, userId): Observable<any>{
    return this.httpService.httpGet(this.checkResetPath + '/' + token + '/' + userId).pipe(response => {
      return response;
    });
  }

  resetPassword(body): Observable<any>{
    return this.httpService.httpPost(this.resetPath, body).pipe(response => {
      return response;
    });
  }

  registerPassword(body): Observable<any>{
    return this.httpService.httpPost(this.registerPath, body).pipe(response => {
      return response;
    });
  }

  checkLogin(): Observable<any>{
    return this.httpService.httpGet(this.checkPath).pipe(response => {
      return response;
    });
  }


  doLogout(): Observable<any> {
    return this.httpService.httpPost(this.logoutPath, {}).pipe(response => {
      return response;
    });
  }

  doQuickLogin(body, authLogin): Observable<any>{
    if (authLogin){
      return this.httpService.httpPost(this.pathAuth, body).pipe(response => {
        return response;
      });
    }else{
      return this.httpService.httpPost(this.pathQuick, body).pipe(response => {
        return response;
      });
    }
  }

  async getLoginUser(){
    return await this.storage.get(USER_KEY);
  }

  async setLoginUser(email){
    this.storage.set(USER_KEY, email);
  }

  refreshToken(): Observable<any>{
    return this.httpService.httpGet(this.refreshPath).pipe(response => {
      return response;
    });
  }

  async getSessionToken(){
    const token = await this.storage.get(TOKEN_KEY);
    if (token) {
      this.sessionToken = token;
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }

  setSessionToken(token){
    this.sessionToken = token;
    return from(this.storage.set(TOKEN_KEY, token));
  }




}
